import { RootState } from '../../store';

export const getAvailablePrioritiesSelector = (state: RootState) => state?.ticketReducer?.availablePriorities;
